<template>
  <b-modal id="alerts-subscribe-modal" title="Subscribe" size="lg" ok-only>
    <p>
      To subscribe to alerts, please open a chat with our Telegram bot <a href="https://t.me/dKartFleetBot" target="_blank" rel="noopener noreferrer">@dKartFleetBot</a> and follow the instructions.
    </p>
  </b-modal>
</template>

<script>
export default {
  props: {
  },
  data() {
    return {
    }
  },
  computed: {
  }
}
</script>